/**
 * F124: adapt a readable name to the server's route ID, or ask for a usable start.
 * The rule belongs to server_keys/bodies.py; routeName.test.ts holds this adapter
 * against its published OpenAPI schema.
 */
export function deriveServerRouteId(name: string): string | null {
  const routeId = name.trim().toLowerCase().replace(/[^a-z0-9_.-]+/g, "-").slice(0, 64);
  return /^[a-z0-9]/.test(routeId) ? routeId : null;
}
